import { render, staticRenderFns } from "./big-engineer-use-dialog.vue?vue&type=template&id=64848938&scoped=true"
import script from "./big-engineer-use-dialog.vue?vue&type=script&lang=js"
export * from "./big-engineer-use-dialog.vue?vue&type=script&lang=js"
import style0 from "./big-engineer-use-dialog.vue?vue&type=style&index=0&id=64848938&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64848938",
  null
  
)

export default component.exports